export default __webpack_public_path__ + "static/media/slider4-2items.4e913527.svg";